





































import TableActionDropdown from '@/components/TableActionDropdown.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    TableActionDropdown
  }
})
export default class AttributeActionButtons extends Vue {
  @Prop() isRequired!: boolean;
  @Prop({ default: false }) disabled!: boolean;

  get isRequiredAttribute() {
    return this.isRequired;
  }
}
